// 
import image1Stepup from "../assets/img/image1Stepup.jpg"
import image2Stepup from "../assets/img/image2Stepup.jpg"
import image3Stepup from "../assets/img/image3Stepup.jpg"
import image4Stepup from "../assets/img/image4Stepup.jpg"

// 
import image1Shiningstar from "../assets/img/image1Shiningstar.jpg"
import image2Shiningstar from "../assets/img/image2Shiningstar.jpg"
import image3Shiningstar from "../assets/img/image3Shiningstar.jpg"
import image4Shiningstar from "../assets/img/image4Shiningstar.jpg"

// 
import image1teenleader from "../assets/img/image1teenleader.jpg"
import image2teenleader from "../assets/img/image2teenleader.jpg"
import image3teenleader from "../assets/img/image3teenleader.jpg"
import image4teenleader from "../assets/img/image4teenleader.jpg"
import image5teenleader from "../assets/img/image5teenleader.jpg"
import image6teenleader from "../assets/img/image6teenleader.jpg"

//

export const stepUp = {
  title: 'TIẾNG ANH MẦM NON',
  data: [{
    image: image1Stepup,
    subtitle: 'Dành cho trẻ em từ 3 - 3.5 tuổi',
    sortDescription: 'Đến với lớp Step Up, học viên sẽ được học thông qua các hoạt động vui chơi thú vị và đầy cảm hứng và tiếp xúc với ngôn ngữ một cách tự nhiên với đội ngũ giáo viên chất lượng quốc tế, tận tâm.'
  },
  {
    image: image2Stepup,
    subtitle: 'Dành cho trẻ em từ 3.5 - 4.5 tuổi',
    sortDescription: 'Học viên sẽ được làm quen với bảng chữ cái, từ, cụm từ, và cách tiếp xúc với ngôn ngữ thường xuyên nhất thông qua các bài hát phù hợp lứa tuổi, các hoạt động tương tác sống động, đọc, viết và kể chuyện.'
  },
  {
    image: image3Stepup,
    subtitle: 'Dành cho trẻ em từ 4.5 - 5.5 tuổi',
    sortDescription: 'Học viên sẽ được học về những động từ chỉ hành động, những cộng đồng và thời tiết. Trong suốt khóa học, học viên sẽ nhận thức và có thể nói được những câu ở thì hiện tại tiếp diễn ở một vài bối cảnh khác nhau. Học viên cũng sẽ được học đồ chữ cái và các từ vựng.'
  },
  {
    image: image4Stepup,
    subtitle: 'Dành cho trẻ em từ 5.5 - 6.5 tuổi',
    sortDescription: 'Học viên sẽ được học về bãi biển, các phương tiện đi lại, các lễ hội, nhạc cụ và đại dương. Trong suốt khóa học, học viên sẽ có thể nói những câu hoàn chỉnh về những chủ đề này và sử dụng tiếng Anh một cách tự tin.'
  }
  ]
}

export const shiningstart = {
  title: 'TIẾNG ANH THIẾU NHI',
  data: [
    {
      image: image1Shiningstar,
      subtitle: 'Cấp độ Vỡ lòng',
      sortDescription: 'Cấp độ Vỡ lòng giúp học viên xây dựng nền tảng để có thể nói tiếng Anh một cách tự tin. Sau khi kết thúc khóa học cuối của cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế Starters của Cambridge English.',
    },
    {
      image: image2Shiningstar,
      subtitle: 'Cấp độ Sơ cấp',
      sortDescription: 'Cấp độ Sơ cấp sẽ phát triển khả năng mô tả và so sánh, đối chiếu thế giới của học viên với những người xung quanh. Sau khi hoàn thành khóa học cuối của cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế Movers của Cambridge English.',
    },
    {
      image: image3Shiningstar,
      subtitle: 'Cấp độ Sơ trung cấp',
      sortDescription: 'Cấp độ Sơ trung cấp sẽ giúp học viên phát triển ngữ pháp và đạt được độ chính xác khi mô tả và bày tỏ ý kiến. Sau khi hoàn thành cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế Flyers và KET của Cambridge English.',
    },
    {
      image: image4Shiningstar,
      subtitle: 'Cấp độ Trung cấp',
      sortDescription: 'Cấp độ Trung cấp mở rộng vốn từ vựng và trình độ ngữ pháp của học viên, đồng thời phát triển khả năng sử dụng ngôn ngữ phức tạp một cách tự nhiên. Sau khi hoàn thành cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế PET của Cambridge English.',
    },
  ]
}

export const teenleader = {
  title: 'TIẾNG ANH THIẾU NIÊN',
  data: [
    {
      image: image1teenleader,
      subtitle: 'Cấp độ Vỡ lòng',
      sortDescription: 'Cấp độ Vỡ lòng giúp học viên xây dựng nền tảng để có thể nói tiếng Anh một cách tự tin. Sau khi kết thúc khóa học cuối của cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế Movers của Cambridge English.'
    },
    {
      image: image2teenleader,
      subtitle: 'Cấp độ Sơ cấp',
      sortDescription: 'Cấp độ Sơ cấp sẽ phát triển khả năng mô tả và so sánh, đối chiếu thế giới của học viên với những người xung quanh. Sau khi hoàn thành khóa học cuối của cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế Flyers của Cambridge English.'
    },
    {
      image: image3teenleader,
      subtitle: 'Cấp độ Sơ trung cấp',
      sortDescription: 'Cấp độ Sơ trung cấp sẽ giúp học viên phát triển ngữ pháp và đạt được độ chính xác khi mô tả và bày tỏ ý kiến. Sau khi hoàn thành cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế KET của Cambridge English.'
    },
    {
      image: image4teenleader,
      subtitle: 'Cấp độ Trung cấp',
      sortDescription: 'Cấp độ Trung cấp mở rộng vốn từ vựng và trình độ ngữ pháp của học viên đồng thời phát triển khả năng sử dụng ngôn ngữ phức tạp một cách tự nhiên. Sau khi hoàn thành cấp độ này, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế PET của Cambridge English.'
    },
    {
      image: image5teenleader,
      subtitle: 'Cấp độ Cao trung cấp',
      sortDescription: 'Cấp độ Cao trung cấp hoàn thiện trình độ ngữ pháp của học viên, giúp các em có thể trình bày một cách chính xác bằng tiếng Anh. Đến thời điểm này học viên đã có thể sử dụng ngôn ngữ như người bản xứ. Sau khóa cuối, học viên được khuyến khích tham dự kỳ thi chứng chỉ quốc tế FCE của Cambridge English.'
    },
    {
      image: image6teenleader,
      subtitle: 'Cấp độ Cao cấp',
      sortDescription: 'Cấp độ Cao Cấp phát triển nhận thức của học viên về tiếng Anh ở mức cao nhất. Học viên ở cấp độ này sẽ sử dụng tiếng Anh một cách thành thạo tự nhiên gần như người bản xứ.'
    },
  ]
}

